import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import BillContractSelect from './BillContractSelect';
import BillContractSelectService from '../services/BillContractSelectService';

class BillContractSelectContainer extends React.Component {
  contractSelectService = new BillContractSelectService();

  componentDidMount() {
    this.contractSelectService.load();
    this.contractSelectService.handleFindContract(get(this.props.values, 'contract'));
  }

  componentDidUpdate(prevProps) {
    const contractId = get(this.props.values, 'contract');
    if (contractId !== get(prevProps.values, 'contract')) {
      this.contractSelectService.handleFindContract(contractId);
    }
  }

  handleSearch = debounce((value) => {
    this.contractSelectService.handleSearch(value);
  }, 500);

  render() {
    return (
      <BillContractSelect
        disabled={this.props.disabled}
        onChange={this.props.onChange}
        onSearch={this.handleSearch}
        submitting={this.props.submitting}
        errors={this.props.errors}
        values={this.props.values}
        loading={this.props.loading}
        fetching={this.contractSelectService.fetching}
        required={this.props.required}
        contracts={toJS(this.contractSelectService.contracts)}
      />
    );
  }
}

BillContractSelectContainer.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.object,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  loading: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

BillContractSelectContainer.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  loading: false,
  required: false,
  disabled: false,
};

export default observer(BillContractSelectContainer);
